import React from 'react';
import { Timeline } from 'primereact/timeline';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { resolveActionText, resolveRoleText } from '../../../../../utils/dealerApprovalEnums';
import { formatDateWithTime } from '../../../../../utils/dateUtils';

const ApprovalHistory = ({ history = [] }) => {
    const { th } = useLanguage();

    const content = (item) => (
        <div className="mb-3">
            <div className="font-bold">{resolveActionText(th, item.action)}</div>
            <div className="text-sm">
                {item.actionByName}
                {item.role ? ` — ${resolveRoleText(th, item.role)}` : ''}
                {item.actionDate ? ` — ${formatDateWithTime(item.actionDate, true)}` : ''}
            </div>
            {item.note && <div className="text-sm font-italic mt-1">“{item.note}”</div>}
        </div>
    );

    return (
        <div>
            <h5>{th('dealerApproval.historyTitle')}</h5>
            <Timeline className="da-timeline" align="left" value={history} content={content} />
        </div>
    );
};

export default ApprovalHistory;
